<template>
  <div>
    <form role="form">
      <div class="box-body">
        <div class="form-group">
          <label for="title">Título</label>
          <input type="text" class="form-control" id="title" placeholder="Entre com o título" v-model="news.title">
          <p v-if="errors.title" class="text-red">{{ errors.title }}</p>
        </div>
        <div class="form-group">
          <label for="date">Data</label>
          <DatePicker
            placeholder="Selecione a data"
            v-model="news.dateTime"
            :bootstrapStyling="true"
            :language="datepickerLanguage"
          >
          </DatePicker>
          <p v-if="errors.dateTime" class="text-red">{{ errors.dateTime }}</p>
        </div>
        <div class="box-header with-border">
          <h3 class="box-title">Conteúdo</h3>
        </div>
        <div class="box-body pad">
          <vue-html5-editor :content="news.content" @change="updateContent" :height="300"></vue-html5-editor>
          <p v-if="errors.content" class="text-red">{{ errors.content }}</p>
        </div>
      </div>
      <div class="box-footer">
        <button type="submit" class="btn btn-sm btn-primary pull-right" v-on:click.prevent="onSubmit">
          <i class="fa fa-save"></i>&nbsp; Salvar
        </button>
        <go-back-button></go-back-button>
      </div>
    </form>
  </div>
</template>

<script>
import GoBackButton from '@/components/elements/GoBackButton'
import DatePicker from 'vuejs-datepicker'
import { ptBR } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'NewsForm',
  components: { GoBackButton, DatePicker },
  props: ['news', 'errors', 'onSubmit'],
  data () {
    return {
      datepickerLanguage: ptBR
    }
  },
  methods: {
    updateContent (data) {
      this.news.content = data
    }
  }
}
</script>



// WEBPACK FOOTER //
// NewsForm.vue?cf9fb7ac